<template>
  <div class="seek_list_page">
    <div class="filter-container" ref="tools">
      <el-form
        :inline="true"
        :model="formInline"
        class="search-container"
        :label-width="labelWidth"
      >
        <el-form-item :label="$t('climant.climantNumber') + ':'">
          <el-input
            v-model="formInline.claimStatementNum"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('climant.climantStatus') + ':'">
          <el-select v-model="formInline.status" filterable clearable>
            <el-option :label="$t('home.all')" value=""></el-option>
            <el-option :label="getStatusText(0)" value="0"></el-option>
            <el-option :label="getStatusText(1)" value="1"></el-option>
            <el-option :label="getStatusText(2)" value="2"></el-option>
            <el-option :label="getStatusText(3)" value="3"></el-option>
            <el-option :label="getStatusText(4)" value="4"></el-option>
            <el-option :label="getStatusText(5)" value="5"></el-option>
            <el-option :label="getStatusText(6)" value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="VIN:">
          <el-input
            v-model="formInline.vin"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('home.brand') + ':'">
          <el-input
            v-model="formInline.carBrand"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('home.carType') + ':'">
          <el-input
            v-model="formInline.carModel"
            :placeholder="$t('home.placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('climant.applicationDate') + ':'">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            :start-placeholder="$t('cart.startDate')"
            :end-placeholder="$t('cart.endDate')"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="searchButton">
        <div>
          <el-button
            type="primary"
            class="primary-btn"
            icon="el-icon-plus"
            @click="handleAdd()"
            >{{ $t("claimantActivity.applyActivityClaim") }}</el-button
          >
          <el-button
            type="primary"
            class="primary-btn"
            plain
            icon="el-icon-download"
            @click="handleExport()"
            >{{ $t("cart.export") }}</el-button
          >
        </div>
        <div>
          <el-button type="primary" class="primary-btn" @click="onSearch">
            <i class="subSearch-icon"></i>
            {{ $t("home.query") }}
          </el-button>
          <el-button class="primary-btn" plain @click="handleResetQuery">
            <i class="el-icon-refresh-right"></i>
            {{ $t("home.reset") }}
          </el-button>
        </div>
      </div>
    </div>
    <!--    <el-tabs-->
    <!--      v-model="activeName"-->
    <!--      class="tabs-container"-->
    <!--      @tab-click="handleClick"-->
    <!--    >-->
    <!--      <el-tab-pane :label="$t('home.all')" name="all"></el-tab-pane>-->
    <!--      <el-tab-pane :label="$t('climant.drafts')" name="0"></el-tab-pane>-->
    <!--      <el-tab-pane :label="$t('climant.rejected')" name="2"></el-tab-pane>-->
    <!--      <el-tab-pane :label="$t('climant.claimsRejected')" name="5"></el-tab-pane>-->
    <!--      <el-tab-pane-->
    <!--        :label="$t('climant.settleAccounts')"-->
    <!--        name="12"-->
    <!--      ></el-tab-pane>-->
    <!--    </el-tabs>-->
    <div class="list">
      <el-table
        stripe
        border
        ref="singleTable"
        :data="tableData"
        highlight-current-row
        :max-height="maxHeight"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          type="index"
          :label="$t('cart.xh')"
          width="50"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="claimStatementNum"
          :label="$t('climant.climantNumber')"
          min-width="150"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="vinCount"
          :label="$t('claimantActivity.vinCount')"
          min-width="100"
          :render-header="$globalRenderHeader"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="createTime"
          :label="$t('climant.applicationDate')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime ? scope.row.createTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          property="auditResultDisplay"
          :label="$t('climant.climantStatus')"
          min-width="120"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            <span :style="{ color: getStatusColor(scope.row.status) }">
              {{ getStatusText(scope.row.status) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="updateTime"
          :label="$t('climant.examineDate')"
          min-width="160"
          :render-header="$globalRenderHeader"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.updateTime ? scope.row.updateTime.replace('T', ' ') : '' }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('cart.operate')"
          :width="{ ru: 380, en: 220, vi: 240, es: 240 }[$i18n.locale] || 200"
          fixed="right"
          :render-header="$globalRenderHeader"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetail(scope.row)">{{
              $t("operate.view")
            }}</el-button>
            <el-button
              v-if="scope.row.status == 0 || scope.row.status == 2"
              type="text"
              @click="handleEdit(scope.row)"
              >{{ $t("home.edit") }}</el-button
            >
            <el-button
              v-if="scope.row.status == 0 || scope.row.status == 2"
              type="text"
              @click="
                handleChangeStatus(scope.row, '1', 'climant.submitClimant')
              "
              >{{ $t("seek.submit") }}</el-button
            >
            <!-- 撤回 -->
            <el-button
              v-if="
                scope.row.status === 1 ||
                scope.row.status === 3
              "
              type="text"
              @click="
                handleChangeStatus(scope.row, '6', 'climant.revocateClimant')
              "
            >{{ $t("operate.revocate") }}</el-button
            >
            <el-button
              v-if="scope.row.status == 0 ||
                    scope.row.status == 1 ||
                    scope.row.status == 3
                 "
              type="text"
              @click="
                handleChangeStatus(scope.row, '5', 'climant.cancelClimant')
              "
              >{{ $t("seek.cancel") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fenye">
      <pagination
        v-if="total > 0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="changePage"
      />
    </div>
  </div>
</template>
<script>
import {
  activityClaimantList,
  updateActivityClaimStatus,
  exportActivityClaim,
} from "@/api/activityClaimant";
import { setStorage, setStorageNew } from "@/util/localStor";
import { getDownloadFiles } from "@/util/downFile";

export default {
  data() {
    const { data, pageNum, pageSize } = this.$route.query.searchObj
      ? JSON.parse(this.$route.query.searchObj)
      : {};

    return {
      activeName: "all",
      formInline: {
        claimStatementNum: "",
        status: "",
        vin: "",
        carBrand: "",
        carModel: "",
        date: "",
      },
      nowSearch: {
        claimStatementNum: "",
        status: "",
        vin: "",
        carBrand: "",
        carModel: "",
        createTimeStart: "",
        createTimeEnd: "",
      },
      tableData: [],
      page: Number(pageNum) || 1,
      pageSize: Number(pageSize) || 30,
      total: 0,
      recordsSearchObj: data,
      maxHeight: null,
    };
  },
  computed: {
    labelWidth() {
      const widthMap = {
        zh: "95px",
        en: "130px",
        ru: "170px",
        fa: "150px",
        vi: "205px",
        es: "190px",
      };
      return widthMap[this.$i18n.locale] || "150px";
    },
  },
  mounted() {
    this.nowSearch = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.nowSearch;
    this.formInline = this.recordsSearchObj
      ? JSON.parse(JSON.stringify(this.recordsSearchObj))
      : this.formInline;
    this.getList();
  },
  watch: {
    "$i18n.locale"(newValue) {
      this.getTableHighest(this, "maxHeight");
    },
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        0: this.$t("claimantActivity.draft"),
        1: this.$t("claimantActivity.pendingReview"),
        2: this.$t("claimantActivity.rejected"),
        3: this.$t("claimantActivity.pendingSettlement"),
        4: this.$t("claimantActivity.settled"),
        5: this.$t("claimantActivity.canceled"),
        6: this.$t("claimantActivity.withdrawn"),
      };
      return statusMap[status] || "";
    },
    getStatusColor(status) {
      const colorMap = {
        0: "#909399",
        1: "#E6A23C",
        2: "#F56C6C",
        3: "#409EFF",
        4: "#67C23A",
        5: "#909399",
        6: "#909399",
      };
      return colorMap[status] || "#909399";
    },
    handleClick() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.activeName === "all" ? "" : this.activeName;
      this.getList();
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.notificationCount > 0) {
        return "warning-row";
      }
      return "";
    },
    changePage(val) {
      this.page = val.page;
      this.pageSize = val.limit;
      this.getList();
    },
    recordSearchObj() {
      this.$router.replace(
        "/activityClaimant?searchObj=" +
          JSON.stringify({
            data: {
              ...this.nowSearch,
              date: this.nowSearch.createTimeStart
                ? [
                    this.nowSearch.createTimeStart.split(" ")[0],
                    this.nowSearch.createTimeEnd.split(" ")[0],
                  ]
                : "",
            },
            pageNum: this.page,
            pageSize: this.pageSize,
          })
      );
    },
    handleDetail(data) {
      this.recordSearchObj();
      this.$router.push({
        name: "activityClaimantDetail",
        query: {
          activityClaimId: data.activityClaimId,
          claimantId: data.claimStatementNum,
        },
      });
      setStorage("activityClaimantData", data);
    },
    handleEdit(data) {
      this.recordSearchObj();
      setStorageNew("activityClaimantData", data);
      this.$router.push("/addActivityClaimant");
    },
    onSearch() {
      this.page = 1;
      this.pageSize = 30;
      this.nowSearch.status = this.formInline.status;
      this.nowSearch.claimStatementNum = this.formInline.claimStatementNum;
      this.nowSearch.vin = this.formInline.vin;
      this.nowSearch.carBrand = this.formInline.carBrand;
      this.nowSearch.carModel = this.formInline.carModel;
      if (this.formInline.date) {
        this.nowSearch.createTimeStart = this.formInline.date[0] + " 00:00:00";
        this.nowSearch.createTimeEnd = this.formInline.date[1] + " 23:59:59";
      } else {
        this.nowSearch.createTimeStart = "";
        this.nowSearch.createTimeEnd = "";
      }
      this.getList();
    },
    async getList() {
      const query = {
        data: {
          ...this.nowSearch,
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize,
        },
      };

      const res = await activityClaimantList(query);
      if (res.status == 0) {
        this.tableData = res.data.records;
        this.total = res.data.count;
      } else {
        this.$DonMessage.warning(res.message);
      }
      this.getTableHighest(this, "maxHeight");
    },
    handleResetQuery() {
      this.formInline = {
        status: "",
        claimStatementNum: "",
        vin: "",
        carBrand: "",
        carModel: "",
        date: "",
      };
      this.onSearch();
    },
    handleAdd() {
      this.recordSearchObj();
      setStorageNew("activityClaimantData", {});
      this.$router.push("/addActivityClaimant");
    },
    async handleExport() {
      const query = {
        data: {
          ...this.nowSearch,
          languageType: this.$i18n.locale,
        },
      };
      const res = await exportActivityClaim(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success(this.$t("request.exportOrder"));
      }
    },
    async handleChangeStatus(row, targetStatus, title) {
      if (title === "climant.submitClimant") {
        if (row.status != 0 && row.status != 2) {
          this.$DonMessage.warning(this.$t("claimantActivity.submitTip"));
          return;
        }
      } else if (title === "climant.cancelClimant") {
        if (row.status !== 0 && row.status !== 2) {
          this.$DonMessage.warning(this.$t("claimantActivity.cancelTip"));
          return;
        }
      }
      await this.$confirm(
        `${this.$t(title) + ":" + row.claimStatementNum}？`,
        this.$t("request.tips"),
        {
          cancelButtonClass: "confirm-btn-close",
          confirmButtonClass: "confirm-btn-confirm",
        }
      );
      const res = await updateActivityClaimStatus({
        data: {
          activityClaimId: row.activityClaimId,
          status: targetStatus,
        },
      });
      if (res.status == 0) {
        this.$DonMessage.success(this.$t("message.czcg"));
        this.getList();
      } else {
        this.$DonMessage.warning(res.message);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .list .table-btn {
  margin-top: 0;
}
</style>
